export enum ClassName {
    DATA_COLLECTOR_PLUGIN = 'com.ust.processor.plugin.JsonDataCollectorPlugin',
    DATA_TRANSFORMER_PLUGIN = 'com.ust.processor.plugin.JsonDataTransformerPlugin',
    WORKFLOW_PLUGIN = 'com.ust.processor.plugin.SimpleActionWorkflowPlugin',
}
